module.exports = __webpack_public_path__ + "img/bg-details-head.07755a10.png";